import { AxiosResponse } from 'axios';
import { IPageParams, TPhoto } from 'common/types/common-types';
import { IReview, IGetReviewsResponse } from 'common/types/review';

import { $host } from './index';

const headers = { 'Content-Type': 'multipart/form-data' };

export const getReviews = async (params?: IPageParams) => {
  const {
    data: { data },
  } = await $host.get<AxiosResponse<IGetReviewsResponse>>('admin/reviews', {
    params: params ?? { page: 1, pageSize: 50 },
  });

  return data;
};

export interface ICreateReviewParams {
  productId: number;
  reviewerName: string;
  rating: number;
  reviewText?: string | null;
  photos?: TPhoto[];
}

export const createReview = async (params: ICreateReviewParams) => {
  const formData = new FormData();
  formData.append('productId', String(params.productId));
  formData.append('reviewerName', params.reviewerName);
  formData.append('rating', String(params.rating));
  if (params.reviewText) {
    formData.append('reviewText', params.reviewText);
  }
  if (params.photos?.length) {
    params.photos.forEach((photo) => {
      if (photo.file) {
        formData.append('photos', photo.file);
      }
    });
  }

  const {
    data: { data },
  } = await $host.post<AxiosResponse<IReview>>('admin/reviews', formData, {
    headers,
  });

  return data;
};

export const deleteReviewById = async (id: number) => {
  const {
    data: { data },
  } = await $host.delete<AxiosResponse<IReview>>(`admin/reviews/${id}`);

  return data;
};
